export const GetPolicyLink = (country, language) => {
  return country === 'US'
    ? '/policy-us/'
    : language === 'de'
    ? '/policy-de/'
    : '/policy/'
}
